/**
 * Handle the redirect back from Google OAuth.
 * Called globally on app mount. If the URL has ?google_auth=success&token=...,
 * persist the user + token and clean the URL.
 */
export type GoogleUser = {
  email: string
  name?: string
  picture?: string
  token: string
  provider: 'google'
}

export function getGoogleUser(): GoogleUser | null {
  try {
    const raw = localStorage.getItem('cs_user')
    return raw ? (JSON.parse(raw) as GoogleUser) : null
  } catch {
    return null
  }
}

export function signOutGoogle() {
  localStorage.removeItem('cs_user')
  localStorage.removeItem('cs_user_token')
}

/**
 * Process ?google_auth=... on page load.
 * Returns the user if auth just completed, else null.
 */
export function handleGoogleCallback(): GoogleUser | null {
  const p = new URLSearchParams(window.location.search)
  const status = p.get('google_auth')
  if (!status) return null

  // Always strip the query string so tokens don't linger in URL/bookmarks
  const cleanUrl = window.location.pathname + window.location.hash
  window.history.replaceState({}, document.title, cleanUrl)

  if (status !== 'success') {
    console.warn('[google-auth] failed:', p.get('reason'))
    return null
  }

  const token = p.get('token') || ''
  const email = p.get('email') || ''
  const name = p.get('name') || ''
  const picture = p.get('picture') || ''
  if (!token || !email) return null

  const user: GoogleUser = { email, name, picture, token, provider: 'google' }
  localStorage.setItem('cs_user', JSON.stringify(user))
  localStorage.setItem('cs_user_token', token)
  sessionStorage.setItem('cs_fresh_login', '1')
  console.log('[google-auth] ✓ signed in as', email)
  return user
}
